import api from './api';

export const contactService = {
  getContacts: async (projectId) => {
    const response = await api.get('/contacts', { params: { project: projectId } });
    return response.data;
  },

  getContact: async (id) => {
    const response = await api.get(`/contacts/${id}`);
    return response.data;
  },

  createContact: async (data) => {
    const response = await api.post('/contacts', data);
    return response.data;
  },

  updateContact: async (id, data) => {
    const response = await api.put(`/contacts/${id}`, data);
    return response.data;
  },

  deleteContact: async (id) => {
    const response = await api.delete(`/contacts/${id}`);
    return response.data;
  }
};
